import React from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { useAmplitude } from '~/utils/hooks';

const getPagePrefix = (pathname: string): string => {
  if (pathname.startsWith('/login')) return 'login';
  if (pathname.startsWith('/profile')) return 'profile';
  if (pathname.startsWith('/courses')) return 'library';
  if (pathname.includes('guides')) return 'guides';
  return 'mainpage';
};

interface AppDownloadBannerProps {
  appUrl: string;
  onClose: () => void;
}

export const AppDownloadBanner: React.FC<AppDownloadBannerProps> = ({
  appUrl,
  onClose,
}) => {
  const { t } = useTranslation();
  const sendEvent = useAmplitude();
  const { pathname } = useLocation();
  const pagePrefix = getPagePrefix(pathname);

  const handleOpen = () => {
    sendEvent(`${pagePrefix}_switch_pop_up_click`);
    window.open(appUrl, '_blank');
  };

  const handleClose = () => {
    sendEvent(`${pagePrefix}_switch_pop_up_skip`);
    onClose();
  };

  return createPortal(
    <div className="app-download-banner">
      <div className="app-download-banner-text">
        <strong className="app-download-banner-title">
          {t('components.appDownload.bannerTitle')}
        </strong>
        <span className="app-download-banner-subtitle">
          {t('components.appDownload.bannerSubtitle')}
        </span>
      </div>

      <button className="app-download-banner-open-btn" onClick={handleOpen}>
        {t('components.appDownload.bannerOpen')}
      </button>

      <button className="app-download-banner-close-btn" onClick={handleClose}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M18 6.5L6 18.5"
            stroke="#16321F"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M6 6.5L18 18.5"
            stroke="#16321F"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </button>
    </div>,
    document.getElementById('modal')!
  );
};
